// extracted by mini-css-extract-plugin
export default {"buttonContainer":"lkbus","alignToEdge":"ZvUWu","buttonIcon":"OBEk-","buttonCaption":"JOpZ7","buttonSpacer":"UfIqf"};